import { useEffect, useState } from "react";
import axios from "axios";
import { apiLabelUrl } from "../Functions/functions";

export default function useProductSettingsExclusions(loggedInUserParam) {
    const [productSettingsExclusions, setProductSettingsExclusions] = useState([]);

    useEffect(() => {
        let mounted = true;
        const fetchExclusions = async () => {
            try {
                const userId = loggedInUserParam?.id ?? null;
                if (!userId) return;
                const base = await apiLabelUrl("api");
                const url = `${base}/product/exclusions?user_id=${encodeURIComponent(userId)}`;
                const response = await axios.get(url);
                if (mounted) setProductSettingsExclusions(response.data || []);
            } catch (error) {
                console.error(
                    "Failed fetching product exclusions:",
                    error?.response?.status ?? "",
                    error?.message ?? error
                );
            }
        };

        fetchExclusions();
        return () => {
            mounted = false;
        };
    }, [loggedInUserParam?.id]);

    return [productSettingsExclusions, setProductSettingsExclusions];
}
